import { defineComponent as _defineComponent } from 'vue'
import { ref, useTemplateRef, watch, computed } from 'vue';
    import * as z from "zod";
    import { update_user } from '../../module/users/module';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'edit_user',
  props: ['user', 'open'],
  emits: [
        'finished',
    ],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

    let props = __props
    const emit = __emit

    let dat_loading = ref(false)
    let dat_username = ref('')
    let dat_email = ref('')
    let dat_username_error = ref('')
    let dat_email_error = ref('')

    let user_schema = z.object({
        username: z.string().min(1, "Username is required"),
        email: z.email().min(1, "Email is required"),
    });

    function cleanErrors (error: z.ZodError, field: string) {
        const loc_errors = error.issues
            .filter((tmp_issue) => {
                return tmp_issue.path.includes(field)
            })
            .map((tmp_issue) => {
                return tmp_issue.message
            })
        
        if (loc_errors.length > 0) {
            return loc_errors.join(', ')
        } else {
            return ""
        }
    }

    const ref_dialog = useTemplateRef('dialog')

    const reset_component = function() {
        dat_username.value = ""
        dat_email.value = ""
        dat_username_error.value = ""
        dat_email_error.value = ""
    }
    
    let com_open = computed(() => {
        return props.open
    })

    watch(com_open, () => {
        const loc_dialog: HTMLDialogElement | null = ref_dialog.value

        if (loc_dialog === null) {
            return
        }

        loc_dialog.showModal()

        dat_username.value = props?.user.username ?? ""
        dat_email.value = props?.user.email ?? ""
    })


    const save = async function(arg_username: string, arg_email: string) {
        const result = user_schema.safeParse({ username: arg_username, email: arg_email});
        if (!result.success) {

            dat_username_error.value = cleanErrors(result.error, 'username')
            dat_email_error.value = cleanErrors(result.error, 'email')
            return
        } else {
            dat_loading.value = true
            const loc_user = await update_user(props.user.id, arg_username, arg_email)
            dat_loading.value = false
            const loc_dialog: HTMLDialogElement | null = ref_dialog.value
            
            emit('finished')

            if (loc_dialog === null) {
                return
            }
            reset_component()
            loc_dialog.close()

            
        }

        
    }

    const cancel = function () {
        reset_component()

        const loc_dialog: HTMLDialogElement | null = ref_dialog.value
        
        if (loc_dialog === null) {
            return
        }

        loc_dialog.close()
    }


const __returned__ = { get props() { return props }, set props(v) { props = v }, emit, get dat_loading() { return dat_loading }, set dat_loading(v) { dat_loading = v }, get dat_username() { return dat_username }, set dat_username(v) { dat_username = v }, get dat_email() { return dat_email }, set dat_email(v) { dat_email = v }, get dat_username_error() { return dat_username_error }, set dat_username_error(v) { dat_username_error = v }, get dat_email_error() { return dat_email_error }, set dat_email_error(v) { dat_email_error = v }, get user_schema() { return user_schema }, set user_schema(v) { user_schema = v }, cleanErrors, ref_dialog, reset_component, get com_open() { return com_open }, set com_open(v) { com_open = v }, save, cancel }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})